var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-compte"},[_c('div',{staticClass:"container"},[_c('account'),_c('hr'),_c('sales'),_c('hr'),_c('stock'),_c('hr'),_c('users'),_c('hr')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }